/* @ts-self-types="./frameworkAssets.d.ts" */
/**
 * First-party framework asset paths: the application's own runtime chunks,
 * which are never a tracker.
 *
 * ONE list, used in two places so they cannot drift apart:
 *   - the consent script's ScriptBlocker
 *     (packages/consent-script/src/blocking/ScriptBlocker.ts), which never
 *     blocks these, because blocking the app's own runtime would take the page
 *     down;
 *   - the embed load-order finding (beaconEmbed.ts, in this directory), which
 *     does not count these as "running before" Beacon. On a Next.js App Router
 *     site React writes its /_next/static/chunks/*.js tags into <head> ahead of
 *     anything a layout can emit, so a correctly placed loader was still told
 *     that nine other scripts ran before it.
 *
 * It lives here rather than in the consent script because the edge functions
 * are deployed from supabase/functions alone, while the consent script's
 * bundler follows a relative import anywhere in the repository. It is plain
 * JavaScript, typed by frameworkAssets.d.ts next to it, because the consent
 * script's TypeScript plugin only compiles files inside that package; rollup
 * reads JavaScript from anywhere. No imports, no Deno or DOM APIs, so the same
 * file runs in the browser bundle, in Deno and under vitest.
 */

/** @type {readonly RegExp[]} */
export const FRAMEWORK_SRC_PATTERNS = Object.freeze([
  /\/_next\/(?:static|image|webpack-hmr)\//i,
  /\/__nextjs_/i,
  /\/_nuxt\//i,
  /\/_app\/immutable\//i,
  /\/_astro\//i,
  /\/build\/_shared\//i,
  /\/_vercel\/(?:insights|speed-insights)\//i,
]);

/**
 * Whether a script src is one of the page's own framework assets.
 * @param {string} src
 * @returns {boolean}
 */
export function isFrameworkAssetSrc(src) {
  return FRAMEWORK_SRC_PATTERNS.some((pattern) => pattern.test(src));
}
